import { useMemo, useState } from "react";
import { mark } from "../lib/stepLog";
import { SCHEME_VARIANTS, schemeFor, tryNavigate } from "../lib/schemeReturn";

// Hidden diagnostics (?debug=return&shop=<handle>&key=<apiKey>&path=/app/...):
// which link opens the Shopify app on this phone, by tap and by script.
export default function ReturnProbe() {
  const q = new URLSearchParams(window.location.search);
  const shop = q.get("shop") || "";
  const key = q.get("key") || "";
  const path = q.get("path") || "";
  const [res, setRes] = useState({});
  const rows = useMemo(() => {
    const https = `https://admin.shopify.com/store/${shop}/apps/${key}${path}`;
    return [{ id: "https", url: https }, ...SCHEME_VARIANTS.map((id) => ({ id, url: schemeFor(id, https) }))];
  }, [shop, key, path]);

  const script = async (r) => {
    setRes((s) => ({ ...s, [r.id]: "trying..." }));
    mark("return_probe", { variant: r.id, via: "script", phase: "start" });
    const out = await tryNavigate(r.url);
    mark("return_probe", { variant: r.id, via: "script", opened: out.opened, ms: out.ms });
    setRes((s) => ({ ...s, [r.id]: out.opened ? `page hidden after ${out.ms} ms: app opened` : "page stayed visible: no app" }));
  };
  const box = { display: "block", padding: 16, margin: "10px 0", border: "1px solid #888", borderRadius: 12, wordBreak: "break-all", font: "15px system-ui", color: "inherit" };
  return (
    <div style={{ padding: 16, font: "15px system-ui", color: "#111", background: "#fff", minHeight: "100vh" }}>
      <h2>Return probe</h2>
      <p>Tap a link, or press the button under it. After an app switch, come back and read the result.</p>
      {rows.map((r) => (
        <div key={r.id} style={box}>
          <b>{r.id}</b>
          <div style={{ fontSize: 12, margin: "6px 0" }}>{r.url}</div>
          <a href={r.url} onClick={() => mark("return_probe", { variant: r.id, via: "tap" })} style={{ display: "block", padding: 14, background: "#222", color: "#fff", borderRadius: 10, textAlign: "center", margin: "6px 0" }}>Open (tap)</a>
          <button onClick={() => script(r)} style={{ width: "100%", padding: 14, fontSize: 16, borderRadius: 10 }}>Try via script redirect</button>
          {res[r.id] ? <div style={{ marginTop: 6 }}>{res[r.id]}</div> : null}
        </div>
      ))}
    </div>
  );
}
